import React from 'react';

/**
 * Inline SVG icon set (phase-7-ui.md §1: no emoji-as-icons on interactive
 * elements). Stroke icons inherit currentColor so they follow the token
 * palette of whatever they sit in.
 */

interface IconProps {
  size?: number;
  className?: string;
}

export const SearchIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}><circle cx="10.5" cy="10.5" r="6.5" /><path d="m16 16 5 5" /></svg>
);
export const ArrowLeftIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}><path d="m14 6-6 6 6 6" /></svg>
);
export const ArrowRightIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}><path d="m10 6 6 6-6 6" /></svg>
);

function svgProps(size: number, className?: string) {
  return {
    width: size,
    height: size,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    className,
    'aria-hidden': true,
    focusable: false,
  };
}

/** Crescent moon — the Luma mark. */
export const MoonIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M20.4 14.2A8.5 8.5 0 0 1 9.8 3.6a8.5 8.5 0 1 0 10.6 10.6z" />
  </svg>
);

export const CompassIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <circle cx="12" cy="12" r="9" />
    <path d="M15.5 8.5l-2 5-5 2 2-5z" />
  </svg>
);

export const BookIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M4 19.5V5a2 2 0 0 1 2-2h14v16.5" />
    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20v4H6.5A2.5 2.5 0 0 1 4 19.5z" />
  </svg>
);

export const MicIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <rect x="9" y="3" width="6" height="11" rx="3" />
    <path d="M5 11a7 7 0 0 0 14 0" />
    <path d="M12 18v3" />
  </svg>
);

export const PencilIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M17 3.5l3.5 3.5L8 19.5 3.5 20.5 4.5 16z" />
  </svg>
);

export const RefreshIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M20 11a8 8 0 1 0-1.5 6.5" />
    <path d="M20 5v6h-6" />
  </svg>
);

export const TrashIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M4 7h16" />
    <path d="M9 7V4h6v3" />
    <path d="M6.5 7l1 13h9l1-13" />
  </svg>
);

export const PlusIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const CheckIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M4.5 12.5l5 5 10-11" />
  </svg>
);

export const CloseIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

export const SparkleIcon: React.FC<IconProps> = ({ size = 24, className }) => (
  <svg {...svgProps(size, className)}>
    <path d="M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8z" />
    <path d="M18.5 16.5l.7 2 2 .7-2 .7-.7 2-.7-2-2-.7 2-.7z" />
  </svg>
);
